import React from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { TableHeader } from '../../../Common/CommonModel';
import { SqlServer } from '../Model/SqlServerModel';
import { EnhancedTableProps } from '../Model/SqlServerProps';

const sqlServerHeader: TableHeader<SqlServer>[] = [
  {
    id: 'ServerName',
    numeric: false,
    disablePadding: false,
    label: 'Server Name',
    enableSorting: true,
  },
  {
    id: 'ProductID',
    numeric: false,
    disablePadding: false,
    label: 'Product ID',
    enableSorting: true,
  },
  {
    id: 'Region',
    numeric: false,
    disablePadding: false,
    label: 'Region',
    enableSorting: true,
  },
  {
    id: 'ResourceGroup',
    numeric: false,
    disablePadding: false,
    label: 'Resource Group',
    enableSorting: true,
  },
  {
    id: 'Role',
    numeric: false,
    disablePadding: false,
    label: 'Role',
    enableSorting: true,
  },
  {
    id: 'Subscription',
    numeric: false,
    disablePadding: false,
    label: 'Subscription',
    enableSorting: true,
  },
];

export default function StorageAccountsTableHead(
  props: Readonly<EnhancedTableProps>,
) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler =
    (property: keyof SqlServer) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {sqlServerHeader.map((column) => (
          <TableCell
            key={column.id}
            align={column.numeric ? 'right' : 'left'}
            padding={column.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === column.id ? order : false}
          >
            {column.enableSorting ? (
              <TableSortLabel
                active={orderBy === column.id}
                direction={order}
                onClick={createSortHandler(column.id)}
              >
                {column.label}
              </TableSortLabel>
            ) : (
              <div>{column.label}</div>
            )}
          </TableCell>
        ))}
        <TableCell align="right"></TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
}
